import { render, staticRenderFns } from "./GridItem.vue?vue&type=template&id=06f09dfa&"
import script from "./GridItem.vue?vue&type=script&lang=js&"
export * from "./GridItem.vue?vue&type=script&lang=js&"
import style0 from "./GridItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports